import axiosInstance from '@/api/axiosInstance';

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  username: string;
  email?: string;
  image: string | null;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  role: string;
}

export const userProfileApi = {
  getUserProfile: async (): Promise<UserProfile> => {
    const response = await axiosInstance.get('/users/me');
    return response.data;
  },

  updateUserProfile: async (
    data: Partial<UserProfile>
  ): Promise<UserProfile> => {
    const response = await axiosInstance.put('/users', data);
    return response.data;
  },
  changePassword: async (data: {
    oldPassword: string;
    newPassword: string;
  }) => {
    const response = await axiosInstance.put('/users/change-password', data);
    return response.data;
  },
};
